import { combineReducers } from "redux";
import setContextData from './syllabus-list-reducer';

export default combineReducers({
    setContextData
})